import React, {useState, useRef} from 'react'
import Sidebar from "../../components/sidebar/Sidebar";
import "../../styles/sidebar/sidebar.css";
import Header from "../../components/header/Header";
import RecordedDataComponent from '../../components/recordedData/RecordedDataComponent';

const SupervisorRecordedData = () => {
    return (
        <>
        <div className="recorded-data-container">
                <Sidebar role="scanner-operator"/>
            <div className="main-content">
                <Header/>
                <RecordedDataComponent role="scanner-operator" title="ARCHIVE SCANNED DATA"/>
            </div>
        </div>
        </>
      )
}

export default SupervisorRecordedData